import {initWebComponent} from "@/helpers/web-component-helper";
import {getDataTableName, initDataTable} from "@/helpers/datatable/datatable-helper";
import {createGeoJsonLayer, toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {initDataTableEditor} from "@/helpers/datatable/datatable-editor-helper";
import {initLoadInfoAfterClick} from "@/helpers/bootstrap-accordion-helper";
import {addServiceMvt, removeInfoMvt} from "@/modules/ol/service/ol-service-mvt";
import {getBookmarkPresentationsByID, getLayerByName, getLayerNamePrefix} from "@/helpers/ol/ol-layer-helper";
import {getWfsStyleFunction} from "@/modules/ol/service/ol-service-wfs";
import {Point} from "ol/geom";
import {
    getKVLayerByBookmarkPresentationID,
    getKVLayerByDomainIDAndPresentationID
} from "@/helpers/kv/kv-layer-helper.js";
import {generateMetaDataHtml} from "@/helpers/meta-data-helper.js";
import {initBoostrapSlider, initBootstrapPluginSlider} from "@/helpers/bootstrap-slider-helper.js";
import {getAllBySelector} from "@/helpers/element-helper.js";

export class LayerInfoInfoItemComponent extends HTMLElement {
    constructor(){
        super();

        const index = this.getAttribute('data-index')
        const depth = this.getAttribute('data-depth')
        const temporaryLayer = this.getAttribute('data-temporary-layer')
        const breadCrumbIndex = this.getAttribute('data-bread-crumb-index')

        const template = document.createElement('template');

        const mainTab = window.mainTabs[index]

        let innerHtml = ``

        let isVisible = true

        if(index > 0 && parseInt(index) !== window.mainTabs.findIndex(mainTab => mainTab.features.length > 0)) {
            isVisible = false
        }

        sliders = []

        window.attributeItems = []
        window.fileIndex = []

        const bookmarkPresentationID = mainTab.BookmarkPresentationID

        let collapseStyle = ''
        let collapseSingleStyle = ''
        if(mainTab.features.length >= 2) {
            collapseStyle = 'max-height: calc(100vh - 220px);overflow-y: auto;overflow-x: hidden;'
        } else {
            collapseSingleStyle = 'max-height: calc(100vh - 220px);overflow-y: auto;overflow-x: hidden;'
        }

        const bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)

        innerHtml += `<div style="${collapseStyle}">`

        if(bookmarkPresentation && bookmarkPresentation.ShowMultipleRecordsInTable && mainTab.features.length > 1) {
            innerHtml += loadMultipleRecordsTable(mainTab)
        } else {
            mainTab.features.map((feature, featureIndex) => {

                window.attributeItems[featureIndex] = []

                const service = getBookmarkPresentationsByID(mainTab.BookmarkPresentationID)
                let styleFunction = undefined
                if(service && ['WFS','WMS'].includes(service.Type)) {
                    if(service.WfsStyle?.styles[0]?.Value) {
                        styleFunction = getWfsStyleFunction(service, true)
                    }
                }

                console.log(styleFunction)

                createGeoJsonLayer(feature.feature, feature.featureInfo[0].FormID + '-' + index, isVisible, '', styleFunction)

                innerHtml += '<layer-info-info-item-info-navigation></layer-info-info-item-info-navigation>'
                innerHtml += `
                <div class="card ml-2 mr-2 bg-light" style="margin-top: 12px;">
                    <div class="card-header p-2">
                        <a href="#" data-bs-target="#collapseInfo` + featureIndex + '-' + index + `" data-bs-toggle="collapse" class="font-weight-bold text-dark accordion-header" aria-expanded="true">
                        
`

                if(mainTab.features.length > 1) {
                    innerHtml += '<span class="badge badge-secondary ml-2">' + (featureIndex + 1) + ' van ' + mainTab.features.length + '</span>'
                }

                innerHtml += ' <div class="collapse-icon float-right mt-2 ml-2"></div>'

                innerHtml += `</a>`

                innerHtml += `<ol class="breadcrumb mb-0 float-left">`
                window.breadCrumbs[breadCrumbIndex].map((breadCrumb, key) => {

                    let active = false
                    if(key === (window.breadCrumbs[breadCrumbIndex].length - 1)) {
                        active = true
                    }

                    innerHtml += `<layer-info-info-bread-crumb data-index="` + breadCrumbIndex + `" data-depth="` + breadCrumb.Depth + `" data-key="` + key + `" data-active="` + active + `" data-name="` + breadCrumb.Name + `"></layer-info-info-bread-crumb></li>`
                })
                innerHtml += `</ol>`

                if(feature.feature.geometry) {
                    innerHtml += `<div class="float-right">
                        <layer-info-info-geometry data-checked="true" data-index="` + index + `"
                                                  data-form-id="` + feature.featureInfo[0].FormID + `"></layer-info-info-geometry> 
                        <layer-info-info-geometry-zoom data-main-tab-index="` + index + `"
                                                       data-feature-index="` + featureIndex + `"></layer-info-info-geometry-zoom> 
                        <layer-info-info-geometry-measure-button data-form-name="` + mainTab.Name + `"
                                                                 data-main-tab-index="` + index + `"
                                                                 data-form-id="${feature.featureInfo[0].FormID}"
                                                                 data-feature-index="` + featureIndex + `"></layer-info-info-geometry-measure-button>
                    </div>`
                }

                const featureInfo = feature.featureInfo
                let tabNames = [... new Set(featureInfo.map(function(obj) { return obj.TabName; }))];
                let activeTab = ''

                innerHtml += `</div>
                    <div class="collapse show pt-1 pb-2" id="collapseInfo` + featureIndex + '-' + index + `" data-parent="#accordion" style="${collapseSingleStyle}">`

                if(tabNames.length > 1) {
                    innerHtml += `<ul class="nav nav-tabs nav-tabs-info">`

                    tabNames.map((tabName, key) => {
                        let active = ''
                        if(key === 0) {
                            active = 'active'
                            activeTab = tabName
                        }
                        innerHtml +=
                        `<layer-info-info-item-sub-tab data-active="` + active + `" data-tab-name="` + tabName + `"></layer-info-info-item-sub-tab>`
                    })

                    innerHtml += `</ul>`
                }

                innerHtml += `<div class="card-body p-0 tab-content tab-content-info">`

                feature.featureInfo = feature.featureInfo.filter(info => info.FormType !== 4)
                feature.featureInfo.map((featureInfo, featureInfoIndex) => {
                    innerHtml += loadFeatureInfo(activeTab, featureInfo, featureInfoIndex, feature, featureIndex, breadCrumbIndex, index, bookmarkPresentationID, undefined, mainTab.features.length)
                })

                innerHtml += `
                </div>
            </div>
        </div>
                `
            })
        }

        innerHtml += ' </div>'

        template.innerHTML = innerHtml

        initWebComponent(this, template)


        getAllBySelector('.chbMarkResult').forEach(element => {
            element.addEventListener('change', (e) => {
                e.preventDefault();

                let rows = element.dataset.rows
                if(parseInt(rows) === 0) {
                    rows = 1000
                }

                for (let i = 0; i < rows; i++) {
                    toggleGeoJsonLayer(element.dataset.formId, i, element.checked)
                }
            })
        })


        sliders.map(slider => {
            initBootstrapPluginSlider(slider.id, slider.layerName)
            this.querySelector('#btnSlider' + slider.id).addEventListener('click', () => {
                const layer = getLayerByName(slider.layerName, false)
                if(layer) {
                    layer.setZIndex(layer.getZIndex())
                }
            })
        })

        this.querySelectorAll('.accordion-header').forEach(element => {
            initLoadInfoAfterClick(element)
        })
    }
}

let sliders = []

export function generateDataTableItem(featureInfo, featureIndex, featureInfoIndex, index, bookmarkPresentationID = undefined, feature = undefined) {
    let dataTableItem = {}
    dataTableItem.FormID = featureInfo.FormID

    if(!bookmarkPresentationID) {
        const kvLayer = getKVLayerByDomainIDAndPresentationID(featureInfo.DomainID, featureInfo.PresentationID)
        if(kvLayer) {
            bookmarkPresentationID = kvLayer.BookmarkPresentationID
        }
    }

    dataTableItem.BookmarkPresentationID = bookmarkPresentationID
    dataTableItem.DomainID = featureInfo.DomainID
    dataTableItem.PresentationID = featureInfo.PresentationID
    dataTableItem.featureInfo = featureInfo
    dataTableItem.FeatureIndex = featureIndex
    dataTableItem.FeatureInfoIndex = featureInfoIndex
    dataTableItem.IsCollapsedDefault = featureInfo.IsCollapsedDefault
    dataTableItem.ShowMultipleRecordsInTable = featureInfo.ShowMultipleRecordsInTable
    dataTableItem.feature = feature
    dataTableItem.Order = []
    dataTableItem.index = index
    dataTableItem.Name = 'dataTable-feature-' + featureIndex + '-info-' + featureInfoIndex  + '-form-' + featureInfo.FormID

    if(featureInfo.records && featureInfo.records.length > 0) {
        dataTableItem.FeatureID = featureInfo.records[0].featureid
    }
    return dataTableItem
}

export function generateDataTableItemAttributes(dataTableItem, featureInfo) {
    dataTableItem.columns = [{data: 'featureid'}]
    dataTableItem.attributes = []
    featureInfo.attributes.map(attribute => {
        attribute.map(attributeItem => {
            dataTableItem.attributes.push(attributeItem)

            const column= generateColumn(attributeItem, dataTableItem)

            dataTableItem.columns.push(column)
        })
    })

    // console.log(dataTableItem)

    return dataTableItem
}

export function generateDataTableMutationAttributes(dataTableItem, featureInfo) {
    dataTableItem.columns = [{data: 'featureid'}]
    dataTableItem.attributes = []
    featureInfo.attributes.map(attributeItem => {
        dataTableItem.attributes.push(attributeItem)

        const column= generateColumn(attributeItem, dataTableItem)
        dataTableItem.columns.push(column)
    })

    // console.log(dataTableItem)

    return dataTableItem
}

function generateColumn(attributeItem, dataTableItem) {
    const column =  {
        data: attributeItem.Attribute,
        display: attributeItem.DisplayName,
        defaultContent: ''
    }

    // Afbeelding
    if(attributeItem.MutationTypeID === 16 && attributeItem.Type !== 1) {
        column.render = function(data) {
            return ''
        }
    }

    return column
}

function loadFeatureInfo(activeTab, featureInfo, featureInfoIndex, feature, featureIndex, breadCrumbIndex, index, bookmarkPresentationID, isFeatureInfoChild = false, featureInfoLength = undefined) {
    let innerHtml = ''

    window.attributeItems[featureIndex][featureInfoIndex] = {}
    window.attributeItems[featureIndex][featureInfoIndex].featureInfo = featureInfo
    window.attributeItems[featureIndex][featureInfoIndex].attributeItems = []
    window.attributeItems[featureIndex][featureInfoIndex].records = []

    if (![0, 1, 8].includes(featureInfo.ApplicationID)) { // || (featureInfo.records.length === 0 && featureInfo.LoadAfterClick !== 1)) {
        return ''
    }

    if (featureInfo.records.length === 0 && featureInfo.ApplicationID !== 1 && featureInfo.LoadAfterClick !== 1) {
        return ''
    }

    let featureInfoMutation = feature.featureInfo[featureInfoIndex - 1]

    if (featureInfoMutation && featureInfo.ApplicationID === 1 && featureInfo.FormName === featureInfoMutation.FormName && featureInfo.records.length > 0) {
        return ''
    }

    // Only show metadata once
    if (featureInfo.ApplicationID === 8 && featureInfo.FormType === 23 && featureInfoLength && featureIndex < (featureInfoLength - 1)) {
        return ''
    }

    let tabHidden = ''
    if (activeTab && activeTab !== featureInfo.TabName) {
        tabHidden = 'd-none'
    }

    let ariaExpanded = 'true'
    let accordionShow = 'show'
    if (featureInfo.IsCollapsed === 1 || featureInfo.LoadAfterClick) {
        ariaExpanded = 'false'
        accordionShow = ''
    }

    let isSingleForm = false

    if (featureInfo.records.length === 1 && featureInfo.ApplicationID !== 1) {
        isSingleForm = true
    }

    if (featureInfo.ApplicationID === 1 && featureInfo.keyColumnType === 2) {
        isSingleForm = true
    }

    if (featureInfo.ApplicationID === 1 && !featureInfo.keyColumnType) {
        isSingleForm = true
    }

    if (isSingleForm && featureInfo.ApplicationID === 1) {
        accordionShow = ''
    }

    let fullWidth = 'w-100'
    if (featureInfo.records.length > 1 || featureInfo.keyColumn) {
        fullWidth = ''
    }

    innerHtml += `
        <div class="card ml-2 mr-2 mt-2 ` + tabHidden + `" data-tab-name="` + featureInfo.TabName + `">
            <div class="card-header p-2">
                <a href="#" class="font-weight-bold accordion-header float-left d-block ${fullWidth}" data-feature-index="${featureIndex}" data-domain-id="` + featureInfo.DomainID + `" data-presentation-id="` + featureInfo.PresentationID + `" data-form-id="` + featureInfo.FormID + `"  data-bs-target="#collapseInfo` + featureIndex + '-' + index + '-' + featureInfoIndex + `" data-bs-toggle="collapse" aria-expanded="` + ariaExpanded + `">
                 `

    innerHtml += '<h4>' + featureInfo.FormName

    if (isSingleForm && featureInfo.ApplicationID === 1) {
    } else {
        innerHtml += ` <div class="collapse-icon mt-1 ml-2"></div>`
    }

    if (featureInfo.keyColumnType !== 2) {
        if (featureInfo.records.length === 1 && featureInfo.keyColumn) {
            innerHtml += `<span class="badge badge-outline-secondary mr-2">1 resultaat</span>`
        } else if (featureInfo.records.length > 1) {
            innerHtml += `<span class="badge badge-outline-secondary mr-2">${featureInfo.records.length} resultaten</span>`
        }
    }

    innerHtml += '</h4>'

    innerHtml += `</a>`

    console.log(featureInfo.records)

    if((featureInfo.records.length > 1 || featureInfo.LoadAfterClick) && (featureInfo.keyColumnType >= 3 || featureInfo.records[0]?.geometry)) {

        let loadAfterClick = ''
        if(featureInfo.LoadAfterClick) {
            loadAfterClick = 'd-none'
        }

        innerHtml += `<label class="switcher ${loadAfterClick}">
        <input type="checkbox" class="switcher-input switcher-secondary chbMarkResult" data-rows="${featureInfo.records.length}" data-form-id="${featureInfo.FormID}" style="display:none;"/>
        <span class="switcher-indicator">
                      <span class="switcher-yes"></span>
                      <span class="switcher-no"></span>
                    </span>
        <span class="switcher-label"></span> Markeren
    </label>`
    }

    if (isSingleForm) {
        innerHtml += loadInfoInfoItemButtons(feature, featureIndex, featureInfo, featureInfoIndex, breadCrumbIndex, index, bookmarkPresentationID)
    }

    let bgClass = 'pt-1'
    let cardBodyClass = 'pl-2 pr-2'
    if (featureInfo.featureInfo && featureInfo.featureInfo.length > 0) {
        bgClass = 'bg-light pt-0 pb-2'
        cardBodyClass = 'p-0 m-0'
    }

    if (featureInfo.ApplicationID === 8) {
        bgClass = ''
    }

    innerHtml += ` </div>
            <div id="collapseInfo` + featureIndex + '-' + index + '-' + featureInfoIndex + `" class="collapse ${bgClass} ` + accordionShow + `" style="">
            `

    switch (featureInfo.ApplicationID) {
        case 8:
            innerHtml += `<layer-info-info-plugin data-feature-key="${featureIndex}" data-main-tab-index="` + index + `" data-feature-info-key="` + featureInfoIndex + `"></layer-info-info-plugin>`
            break;
        case 0:
        case 1:

            if (isSingleForm) {

                addMutationDataTableItem(featureInfo, featureIndex, featureInfoIndex, index, bookmarkPresentationID, feature)

                innerHtml += `<div class="card-body ${cardBodyClass}">`

                const recordIndex = 0
                const record = featureInfo.records[0]

                window.attributeItems[featureIndex][featureInfoIndex].records[recordIndex] = {}
                window.attributeItems[featureIndex][featureInfoIndex].records[recordIndex].attributeItems = []

                if (record) {
                    if (featureInfo.keyColumn !== undefined) {
                        record.projection = feature.feature.projection
                        createGeoJsonLayer(record, featureInfo.FormID + '-' + index, false)
                    }

                    if (record.attributes && featureInfo.ApplicationID !== 1) {

                        let mvtLayer = null

                        record.attributes.map((attribute, key) => {
                            if (attribute.length === 1) {
                                attribute = attribute[0]
                            }

                            if (attribute.Value && typeof attribute.Value === 'string') {
                                if (attribute.Value.includes('}.mvt')) {
                                    if (!mvtLayer) {
                                        mvtLayer = {}
                                    }
                                    mvtLayer.url = attribute.Value
                                }
                                if (attribute.Value.includes('/styles/')) {
                                    if (!mvtLayer) {
                                        mvtLayer = {}
                                    }
                                    mvtLayer.style = attribute.Value
                                }
                            }

                            window.attributeItems[featureIndex][featureInfoIndex].records[recordIndex].attributeItems[key] = attribute
                            innerHtml += `<layer-info-info-type data-feature-key="${featureIndex}" data-record-index="` + recordIndex + `" data-form-type-id="" data-main-tab-index="` + index + `" data-feature-info-key="` + featureInfoIndex + `" data-key="` + key + `" data-child-key=""></layer-info-info-type>`

                        })

                        if (mvtLayer) {
                            let layer = getLayerByName('mvt-info')

                            if (layer && layer.getSource().getUrls()[0] !== mvtLayer.url) {
                                removeInfoMvt()
                                layer = undefined
                            }

                            if (!layer) {
                                const bookmarkPresentation = getBookmarkPresentationsByID(window.lastClickedData.bookmarkPresentationID)

                                console.log(bookmarkPresentation)
                                const service = {
                                    id: 'mvt-info',
                                    Url: mvtLayer.url,
                                    MaxZoom: 11,
                                    Service: {
                                        Projection: 'EPSG:28992'
                                    },
                                    Opacity: bookmarkPresentation.Opacity,
                                    StyleActive: mvtLayer.style,
                                    MinResolution: bookmarkPresentation.MinResolution,
                                    MaxResolution: bookmarkPresentation.MaxResolution
                                }

                                addServiceMvt(window.map, service)
                            }
                        }

                        if (featureInfo.featureInfo) {
                            featureInfo.featureInfo.map((featureInfoChild, featureInfoChildIndex) => {
                                innerHtml += loadFeatureInfo(activeTab, featureInfoChild, featureInfoChildIndex + 1000 + '-' + featureInfoChild.FormID, feature, featureIndex, breadCrumbIndex, index, bookmarkPresentationID, true)

                            })
                        }
                    }
                }

                innerHtml += `</div>`
            } else {


                innerHtml += `<div class="card-body p-2">`
                innerHtml += `
                    <table style="width: 100%;height:100%" class="no-wrap table table-hover dataTable no-footer" id="dataTable-feature-` + featureIndex + `-info-` + featureInfoIndex + `-form-${featureInfo.FormID}">
                        <thead><tr><th>ID</th>`

                let dataTableItem = generateDataTableItem(featureInfo, featureIndex, featureInfoIndex, index, bookmarkPresentationID, feature.feature)

                if (featureInfo.LoadAfterClick === 1) {

                    const data = {
                        json: {
                            geometry: feature.feature.geometry,
                            keyColumn: featureInfo.keyColumn,
                            keyColumnValue: featureInfo.keyColumnValue,
                            keyColumnType: featureInfo.keyColumnType,
                            keyColumnDistance: featureInfo.keyColumnDistance,
                        }
                    }


                    data.PresentationID = featureInfo.PresentationID
                    data.DomainID = featureInfo.DomainID
                    data.FormID = featureInfo.FormID

                    let dataTableItem2 = {}
                    dataTableItem2.FeatureIndex = featureIndex
                    dataTableItem2.FeatureInfoIndex = featureInfoIndex
                    data.Name = getDataTableName(dataTableItem2)

                    window.loadAfterClickForms.push(data)

                    featureInfo.attributes.map(attribute => {
                        attribute.map(attributeItem => {
                            innerHtml += `<th>` + attributeItem.DisplayName + `</th>`
                        })
                    })
                } else {
                    if (featureInfo.attributes) {
                        featureInfo.attributes.map(attribute => {
                            innerHtml += `<th>` + attribute[0].DisplayName + `</th>`
                        })
                    } else {
                        featureInfo.records[0].attributes.map(attribute => {
                            innerHtml += `<th>` + attribute[0].DisplayName + `</th>`
                        })
                    }
                }

                if (featureInfo.attributes) {
                    dataTableItem = generateDataTableItemAttributes(dataTableItem, featureInfo)
                }

                if (featureInfo.PluginFormType === 25) {
                    innerHtml += `<th></th>`
                }

                innerHtml += `</tr></thead>
                        <tbody class="cursor-pointer">`

                if (featureInfo.LoadAfterClick === 1) {
                    featureInfo.attributes.map((attribute, key) => {
                        attribute.map(attributeItem => {
                            if (attributeItem.DisplayOrder !== "") {
                                let direction = 'desc'
                                if (attributeItem.DisplayOrderDirection === "") {
                                    direction = 'asc'
                                }
                                dataTableItem.Order.push([key + 1, direction])
                            }
                        })
                    })
                } else {
                    dataTableItem.hiddenColumns = []
                    featureInfo.records.map((record, recordIndex) => {

                        window.attributeItems[featureIndex][featureInfoIndex].records[recordIndex] = {}
                        window.attributeItems[featureIndex][featureInfoIndex].records[recordIndex].attributeItems = []
                        record.projection = feature.feature.projection
                        createGeoJsonLayer(record, featureInfo.FormID + '-' + recordIndex, false)

                        innerHtml += `<tr>`
                        innerHtml += `<td>` + record.featureid
                        innerHtml += `</td>`
                        record.attributes.map((attribute, key) => {

                            window.attributeItems[featureIndex][featureInfoIndex].records[recordIndex].attributeItems[key] = []

                            const attributeItem = attribute[0]
                            if (recordIndex === 0 && attributeItem.DisplayOrder !== "") {
                                let direction = 'desc'
                                if (attributeItem.DisplayOrderDirection === "") {
                                    direction = 'asc'
                                }
                                dataTableItem.Order.push([key + 1, direction])
                            }

                            innerHtml += `<td>`


                            attribute.map((attributeItemChild, attributeItemChildKey) => {
                                window.attributeItems[featureIndex][featureInfoIndex].records[recordIndex].attributeItems[key][attributeItemChildKey] = attributeItemChild

                                if (featureInfo.PluginFormType === 25 && attributeItemChildKey === 0) {
                                    innerHtml += `
                                    <div class="input-group">
                                        <input
                                        id="slider${recordIndex}"
                                        class="bs-slider-variant"
                                        type="text"
                                        name="somename"
                                        data-provide="slider"
                                        data-slider-min="0"
                                        data-slider-max="100"
                                        data-slider-step="1"
                                        data-slider-value="50"
                                        data-slider-tooltip="hide"
                                        >`

                                    innerHtml += `
                                    <div class="input-group-append">
                                          <button class="btn btn-xs btn-secondary ml-2" id="btnSlider${recordIndex}"><span class="fa fa-arrow-up"></span></button>
                                    </div>`

                                    innerHtml += '</div>'

                                    innerHtml += `</td>`
                                    innerHtml += `<td>`

                                    let sliderItem = {
                                        id: recordIndex,
                                        layerName: attributeItemChild.Value
                                    }

                                    sliders.push(sliderItem)
                                }

                                innerHtml += `<layer-info-info-type data-feature-key="${featureIndex}" data-record-index="` + recordIndex + `" data-is-table="true" data-main-tab-index="` + index + `" data-feature-info-key="` + featureInfoIndex + `" data-key="` + key + `" data-child-key="${attributeItemChildKey}"></layer-info-info-type>`
                            })

                            innerHtml += `</td>`


                            if (
                                (recordIndex === 0) ||
                                (attributeItem.MutationTypeID === 16 && attributeItem.Type !== 1)
                            ) {
                                dataTableItem.hiddenColumns.push({
                                    name: attributeItem.Attribute,
                                    key: key
                                })
                            }

                            // // console.log(attributeItem.Value)
                            if (attributeItem.Value !== '') {
                                dataTableItem.hiddenColumns = dataTableItem.hiddenColumns.filter(item => item.name !== attributeItem.Attribute)
                            }
                        })
                        innerHtml += `</tr>`
                    })
                }
                innerHtml += ` </tbody>
                    </table>
                    `

                window.dataTables.push(dataTableItem)
                innerHtml += `</div>`
            }
            break;
    }


    innerHtml += `
                </div>
            </div>
         `


    return innerHtml
}

function loadInfoInfoItemButtons(feature, featureIndex, featureInfo, featureInfoIndex, breadCrumbIndex, index, bookmarkPresentationID) {

    let innerHtml = ''


    let isLinked = false
    if (featureInfo.keyColumnType) {
        isLinked = true
    }

    let featureInfoMutation = feature.featureInfo[featureInfoIndex + 1]
    if ((featureInfo.ApplicationID === 1 && featureInfo.UserRights && !isLinked) || (featureInfoMutation && featureInfo.FormName === featureInfoMutation.FormName)) {
        innerHtml += `
                      <div class="float-right" style="margin-top:-25px">`
    } else {
        innerHtml += `  
                      <div class="float-right">`
    }


    if(featureInfo.keyColumn !== undefined && featureInfo.records.length > 0 && featureInfo.records[0].geometry !== '') {
        innerHtml += `
                            <layer-info-info-geometry data-checked="false" data-index="` + index + `" data-form-id="` + featureInfo.FormID + `"></layer-info-info-geometry>
                            <layer-info-info-geometry-zoom data-main-tab-index="` + breadCrumbIndex + `"  data-feature-index="` + featureIndex + `" data-feature-info-index="` + featureInfoIndex + `"></layer-info-info-geometry-zoom>`

        innerHtml += ` <layer-info-info-geometry-measure-button
                                     data-form-name="` + featureInfo.FormName + `"
                                     data-main-tab-index="` + breadCrumbIndex + `"
                                     data-feature-index="` + featureIndex + `"
                                     data-feature-info-index="` + featureInfoIndex + `">
                                </layer-info-info-geometry-measure-button>`

    }

    if(featureInfo.IsShowMoreInfoVisible  && featureInfo.records.length > 0 && featureInfo.ApplicationID === 0) {
        innerHtml += `      <layer-info-info-linked-data-button
                                     data-presentation-id="` + featureInfo.PresentationID + `"
                                     data-domain-id="` + featureInfo.DomainID + `"
                                     data-feature-id="` + featureInfo.records[0].featureid + `"
                                     data-index="` + breadCrumbIndex + `"
                            ></layer-info-info-linked-data-button>`
    }

    if(featureInfoMutation && featureInfo.FormName === featureInfoMutation.FormName) {
        featureInfo = featureInfoMutation
        addMutationDataTableItem(featureInfo, featureIndex, featureInfoIndex + 1, index, bookmarkPresentationID, feature)
    }

    if(featureInfo.ApplicationID === 1 && featureInfo.UserRights) {
        innerHtml += '<layer-info-info-mutation-standalone-edit-geometry-save class="d-none"  data-feature-id="' + feature.feature.id + '" data-form-id="' + featureInfo.FormID + '"></layer-info-info-mutation-standalone-edit-geometry-save>'
        innerHtml += '<layer-info-info-mutation-standalone-edit-geometry-cancel class="d-none"  data-feature-id="' + feature.feature.id + '" data-form-id="' + featureInfo.FormID + '"></layer-info-info-mutation-standalone-edit-geometry-cancel>'

        if(featureInfo.keyColumnType === 2) {

            if(featureInfo.records.length > 0) {
                innerHtml += loadEditButtons(featureInfo, feature, isLinked)
            } else {
                // Create data
                if(featureInfo.UserRights.includes(3)) {
                    innerHtml += '<layer-info-info-mutation-standalone-add data-domain-id="' + featureInfo.DomainID + '" data-presentation-id="' + featureInfo.PresentationID + '" data-form-id="' + featureInfo.FormID + '"></layer-info-info-mutation-standalone-add>'
                }
            }
        } else {
            innerHtml += loadEditButtons(featureInfo, feature, isLinked)
        }
    }

    innerHtml += `</div>`

    return innerHtml
}

function addMutationDataTableItem(featureInfo, featureIndex, featureInfoIndex, index, bookmarkPresentationID, feature) {
    if(featureInfo.ApplicationID === 1 && !featureInfo.attributes) {
        featureInfo.attributes = featureInfo.records[0].attributes
    }

    if(featureInfo.attributes) {
        let dataTableItem = generateDataTableItem(featureInfo, featureIndex, featureInfoIndex, index, bookmarkPresentationID, feature.feature)
        dataTableItem = generateDataTableItemAttributes(dataTableItem, featureInfo)
        window.dataTables.push(dataTableItem)
    }
}

function loadEditButtons(featureInfo, feature, isLinked) {

    let innerHtml = ''
    // Remove
    if(featureInfo.UserRights.includes(8)) {
        innerHtml += '<layer-info-info-mutation-standalone-remove data-linked="' + isLinked + '" data-feature-id="' + feature.feature.id + '" data-form-id="' + featureInfo.FormID + '"></layer-info-info-mutation-standalone-remove>'
    }

    let hasGeomAttribute = false
    featureInfo.records[0].attributes.map((attribute) => {
        attribute.map(attributeItem => {
            if(attributeItem.Type === 21) {
                hasGeomAttribute = true
            }
        })
    })

    // Edit geometrie
    if(featureInfo.UserRights.includes(4) && featureInfo.records && featureInfo.records.length > 0 && featureInfo.records[0].geometry && hasGeomAttribute) {
        innerHtml += '<layer-info-info-mutation-standalone-edit-geometry  data-feature-id="' + feature.feature.id + '" data-type="move" data-form-id="' + featureInfo.FormID + '"></layer-info-info-mutation-standalone-edit-geometry>'
        if(featureInfo.records[0] && feature.feature.geometry.type !== 'Point') {
            innerHtml += '<layer-info-info-mutation-standalone-edit-geometry  data-feature-id="' + feature.feature.id + '" data-type="modify" data-form-id="' + featureInfo.FormID + '"></layer-info-info-mutation-standalone-edit-geometry>'
        }
    }

    // Edit data
    if (featureInfo.UserRights.includes(3)) {
        innerHtml += '<layer-info-info-mutation-standalone-edit data-feature-id="' + feature.feature.id + '" data-form-id="' + featureInfo.FormID + '"></layer-info-info-mutation-standalone-edit>'
    }

    return innerHtml
}

/**
 *
 * @param mainTab
 * @returns {string}
 */
function loadMultipleRecordsTable(mainTab) {
    let innerHtml = ''

    const featureInfo = mainTab.features[0]?.featureInfo?.find(featureInfo => featureInfo.FormType === 1)
    const featureIndex = 0
    const featureInfoIndex = 0

    innerHtml += `

    <div class="card ml-2 mr-2 bg-light" style="margin-top: 12px;">
        <div class="card-header p-2">
            <a href="#" class="font-weight-bold text-dark accordion-header">
                ${featureInfo.FormName}
            </a>
        </div>

        <div class="card-body pl-0 pr-0 pt-3 pb-2">
            <table style="width: 100%;height:100%" class="no-wrap table table-hover dataTable no-footer" data-form-id="${featureInfo.FormID}" data-id="dataTable-feature-${featureIndex}-info-${featureInfoIndex}-form-${featureInfo.FormID}" id="dataTable-feature-${featureIndex}-info-${featureInfoIndex}-form-${featureInfo.FormID}">
                <thead>
                    <tr>
                        <th>ID</th>`


        featureInfo.records[0].attributes.map(attribute => {
            attribute.map(attributeItem => {
                innerHtml += `<th>` + attributeItem.DisplayName + `</th>`
            })
        })

        innerHtml += `                        
                    </tr>
                </thead>
                <tbody class="cursor-pointer">`
        mainTab.features.map((feature, index) => {

            createGeoJsonLayer(feature.feature, featureInfo.FormID + '-' + index, true)

            innerHtml += `<tr>`
                innerHtml += `<td>` + feature.feature.id
                innerHtml += `</td>`

                feature.featureInfo.find(featureInfo => featureInfo.FormType === 1).records[0].attributes.map(attribute => {
                    attribute.map(attributeItem => {
                        innerHtml += `<td>` + attributeItem.Value + `</td>`
                    })
                })
            innerHtml += `</tr>`
        })

        innerHtml += `
                </tbody>
            </table>
        </div>
    </div>`

    const metaDataIndex = mainTab.features[0].featureInfo.findIndex(featureInfo => featureInfo.FormType === 23 || featureInfo.FormType === 24)
    if(metaDataIndex >= 0) {
        const kvLayer = getKVLayerByBookmarkPresentationID(mainTab.BookmarkPresentationID)
        if(kvLayer) {
            innerHtml += `
            <div class="card ml-2 mr-2 mt-2 " data-tab-name="Info">
                <div class="card-header p-2">
                    <a href="#" class="font-weight-bold accordion-header float-left d-block w-100"
                    
                       data-feature-index="0" 
                       data-domain-id="${featureInfo.DomainID}" 
                       data-presentation-id="${featureInfo.PresentationID}" 
                       data-form-id="${featureInfo.FormID}"
                       data-bs-target="#collapseInfo0-0-${metaDataIndex}" 
                       
                       data-bs-toggle="collapse" aria-expanded="false">
                        <h4>
                            Metadata <div class="collapse-icon mt-1 ml-2"></div>
                        </h4>
                    </a>
                    <div class="float-right"></div>
                </div>
                <div id="collapseInfo0-0-${metaDataIndex}" class="collapse" style="">
                    <div class="ml-2 mr-2">${generateMetaDataHtml(kvLayer.MetaData)}</div>
                </div>
            </div>`
        }
    }
    // innerHtml += `<layer-info-info-plugin data-feature-key="${featureIndex}" data-main-tab-index="0" data-feature-info-key="` + 1 + `"></layer-info-info-plugin>`

    const dataTableItem = generateDataTableItem(featureInfo, featureIndex, featureInfoIndex, 0, mainTab.BookmarkPresentationID, mainTab.features[0].feature)
    dataTableItem.scrollY = ''
    window.dataTables.push(dataTableItem)

    return innerHtml
}
